import { createSelector } from '@reduxjs/toolkit';

import { chatListSelector } from '../chatListSelector';
import { chatWindowSelector } from '../chatWindowSelector';

export const currentOpenChatIDSelector = createSelector(
  [chatWindowSelector, chatListSelector],
  (chatWindow, chatList) =>
    chatWindow.currentOpenedChatId || chatList.removedFromSpamChatId || chatList.removedFromArchiveChatId,
);
